import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { VisualizerPage } from './visualizer.page';

import { VisualizerPageRoutingModule } from './visualizer-routing.module';
import { SharedComponentsModule } from 'src/app/components/sharedComponents.module';
import { One3DModule } from 'src/app/one3-d/one3-d.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    VisualizerPageRoutingModule,
    SharedComponentsModule,
    One3DModule,
  ],
  exports: [
    TranslateModule
],
  declarations: [VisualizerPage],
})
export class VisualizerPageModule {}
